import React from 'react'
import { usePrivateSale } from 'modules/products'
import { Bone } from 'components/layout'

import OrderProductBase from 'compositions/orderItems/OrderProductBase/OrderProductBase'


type PrivateSaleItemsProps = {
  product: OrderItems.Product
}

const PrivateSaleItems: React.FunctionComponent<PrivateSaleItemsProps> = (props) => {
  const { product: { quantity, productId } } = props
  // TODO don't forget about rebrandImage when privateSale query will be moved to web-api - added on 21.01.2022 by sonatskiy
  const { privateSaleList, isFetching } = usePrivateSale()
  // find required private sale by product id
  const privateSale = privateSaleList?.find((item) => item.id === productId)

  if (isFetching) {
    return (
      <>
        <hr className="mt-24 bg-gray-30" />
        <Bone className="mt-24" pw={100} h={72} />
      </>
    )
  }

  // return null, if we can't find private sale
  if (!privateSale) {
    return null
  }

  return (
    <>
      <hr className="mt-24 bg-gray-30" />
      {
        privateSale.products.map(({ id, name, brand, image, rebrandImage, tradingItems }) => {
          const tradingItem = tradingItems?.items?.[0]
          const size = tradingItem?.volume ? `Vial ${tradingItem.volume.volume} ${tradingItem.volume.unit}` : null

          return (
            <OrderProductBase
              key={id}
              className="mt-24"
              image={image}
              rebrandImage={rebrandImage}
              name={name}
              brand={brand}
              size={size}
              quantity={quantity}
            />
          )
        })
      }
    </>
  )
}


export default PrivateSaleItems
